const PAYLUDD_APP_VERSION_SEPARATOR = '-pax-';

/**
 * Extracts the Payludd app version from strings like "1.32.0-pax-1.29.0-SNAPSHOT".
 * @param {string} version
 * @returns {string}
 */
export function extractPayluddAppVersion(version) {
    return (version || '').split(PAYLUDD_APP_VERSION_SEPARATOR)[0];
}

/**
 * Compares two semantic versions (major.minor.patch).
 * @param {string} versionA
 * @param {string} versionB
 * @returns {number} -1 if versionA < versionB, 0 if equal, 1 if versionA > versionB
 */
export function compareSemanticVersions(versionA, versionB) {
    const parseVersion = (version) => (version || '0.0.0').split('.').map((part) => parseInt(part, 10) || 0);
    const [majorA, minorA, patchA] = parseVersion(versionA);
    const [majorB, minorB, patchB] = parseVersion(versionB);

    if (majorA !== majorB) {
        return majorA - majorB;
    }
    if (minorA !== minorB) {
        return minorA - minorB;
    }
    return patchA - patchB;
}

/**
 * Checks if the Payludd app version is greater than or equal to the target version.
 * @param {string} version Raw version string from API (e.g. "1.32.0-pax-1.29.0-SNAPSHOT")
 * @param {string} targetVersion Target semantic version (e.g. "1.33.0")
 * @returns {boolean}
 */
export function isPayluddAppVersionAtLeast(version, targetVersion) {
    const appVersion = extractPayluddAppVersion(version);
    return compareSemanticVersions(appVersion, targetVersion) >= 0;
}
